const Loader = () => {
    return <span data-type="loader" className="after:border-secondary-500 before:border-primary-500"></span>
}

export default Loader